module.exports = __webpack_public_path__ + "img/td_T6.1 (_Parameter_).f6ea345c.png";